const authenticatedReducer = (
  state = {
    status: null,
    user_id: 0,
    dtc: '9999-99-99',
    name: "",
    token: "",
    userType: "",
    rights: {},
    preferences: {},
    t0_scores: {},
    t1_scores: {},
    rewards: {},
    profile_pic:'',
    email:'',
    gender:'',
    education:'',
    date_time_birth:'',
    firstname:'',
    insertion:'',
    lastname:'',
    organisation_id: 0,
    oldRegistrationFlow: true,
    specialAccountType: '',
    doT0: false,
    onWaitingListRct: false
  },
  action
) => {
  switch (action.type) {
    case "LOGIN":
      return {
        status: true,
        user_id: action.payload.user_id,
        dtc: action.payload.dtc,
        name: action.payload.name,
        token: action.payload.token,
        userType: action.payload.userType,
        rights: action.payload.rights,
        preferences: action.payload.preferences,
        t0_scores: action.payload.t0_scores,
        t1_scores: action.payload.t1_scores,
        rewards: action.payload.rewards,
        profile_pic: action.payload.profile_pic,
        email:action.payload.email,
        private_email:action.payload.private_email,
        gender:action.payload.gender,
        education:action.payload.education,
        date_time_birth:action.payload.date_time_birth,
        firstname:action.payload.firstname,
        insertion:action.payload.insertion,
        lastname:action.payload.lastname,
        organisation_id:action.payload.organisation_id,
        oldRegistrationFlow: action.payload.oldRegistrationFlow,
        specialAccountType: action.payload.specialAccountType,
        doT0: action.payload.doT0,
        onWaitingListRct: action.payload.onWaitingListRct
      };
    case "SET_AUTHENTICATED_FALSE":
      return {
        status: false,
        user_id: 0,
        dtc: '9999-99-99',
        name: "",
        token: "",
        userType: "",
        rights: {},
        preferences: {},
        t0_scores: {},
        t1_scores: {},
        rewards: {},
        profile_pic:'',
        email:'',
        private_email:'',
        gender:'',
        education:'',
        date_time_birth:'',
        firstname:'',
        insertion:'',
        lastname:'',
        organisation_id: 0,
        oldRegistrationFlow: true,
        specialAccountType: '',
        doT0: false,
        onWaitingListRct: false
      };
    case "LOGOUT":
    case "SET_AUTHENTICATED_NULL":
      return {
        status: null,
        user_id: 0,
        dtc: '9999-99-99',
        name: "",
        token: "",
        userType: "",
        rights: {},
        preferences: {},
        t0_scores: {},
        t1_scores: {},
        rewards: {},
        profile_pic:'',
        email:'',
        private_email:'',
        gender:'',
        education:'',
        date_time_birth:'',
        firstname:'',
        insertion:'',
        lastname:'',
        organisation_id: 0,
        oldRegistrationFlow: true,
        specialAccountType: '',
        doT0: false,
        onWaitingListRct: false
      };
    case "SET_USER_PREFERENCES":
      return {
        ...state,
        preferences: action.payload.preferences
      };
    default:
      return state;
  }
};

export default authenticatedReducer;
